import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface UserEntityParams {
  id: number | string;
  email: string;
  first_name: string;
  last_name: string;
}
export class UserEntity extends BaseEntityClass {
  id: number | string;
  email: string;
  first_name: string;
  last_name: string;
  constructor(params: UserEntityParams) {
    super();
    this.type = "user";
    this.entity_version = 2;
    this.id = params.id;
    this.email = params.email;
    this.first_name = params.first_name;
    this.last_name = params.last_name;
  }

  static fromUser(user: any): UserEntity {
    user = _.pick(user, ["id", "email", "first_name", "last_name"]);

    return new UserEntity(user);
  }
}
